/* eslint-disable */
/* Please refactor this file, I temporarily disabled lint on this file to remove the long warnings */
/* Warnings may cause errors or false positive bugs on javascript, lets avoid that */

import React, {Component} from 'react';
import Table from '../../../commons/Table/Table';
import Modal from '../../../commons/Modal/Modal';
import {InputField, DateField, SelectField, TagsInput, TextAreaField, Checkbox} from '../../../commons/Inputs';
import appConfig from '../../../../config';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';
import axios from 'axios';
import BillingStatement from './BillingStatement';

let moment = window.moment;
let Bloodhound = window.Bloodhound;
let $ = window.$;

export default class Payments extends Component {

	state = {
		patient_id : 0,
		headers : [
            {key : 'payment_date', label : 'Payment Date'},
            {key : 'branch', label : 'Branch'},
            {key : 'procedure', label : 'Procedure'},
            {key : 'method', label : 'Payment Method'},
            {key : 'amount_paid', label : 'Amount Paid'},
            {key : 'balance', label : 'Balance'},
            {key : 'status', label : 'Status'},
            {key : 'id', label : 'Id'}, // for table sorting
            {key : 'remarks', label : 'Remarks'}, 
        ],
        data : []
	}

	componentWillMount() {
		this.setState({patient_id : this.props.patient_id});
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.onChangeState)
        {
            $('#paymentsTable').dataTable().fnDestroy();
            let url = appConfig.apiUrl + 'patients/' + this.state.patient_id + '/payments';

            axios.get(url).then((res) => {
                let data = res.data.data;

                data.forEach((item, i) => {
                    if((item.total_bill - Number(item.balance)) > 0)
                    {
                        item.status = 'Partly Paid';
                    }

                    if(Number(item.balance) <= 0)
                    {
                        item.status = 'Fully Paid';

                    }

                    if((item.total_bill - Number(item.balance)) == 0)
                    {
                        item.status = 'Fully Paid';

                    }

                    if(item.is_voided == 1)
                    {
                        item.status = 'Voided';
                    }
                    
                    item.payment_date = moment(item.payment_date).format('MMMM DD, YYYY');
                    item.amount_paid = parseFloat(item.amount_paid).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    item.balance = parseFloat(item.balance).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                });

                this.setState({data},() => {
                    
                    setTimeout(() => {
                        $('#paymentsTable').DataTable({
                            'autoWidth': true,
                            'iDisplayLength': 5,
                            // 'lengthMenu' : [ 5, 10, 20, 50, 100 ],
                            'language' : {
                                "emptyTable" : 'No Payments'
                            },
                            retrieve: true,
                            'columnDefs': [
                                {
                                    'targets': [7,6,5], // id last column
                                    'visible': false,
                                    'searchable': false
                                }
                            ],
                            'order': [[7,'DESC']]
                        });
                    },1000)
                });

            }).catch((error) => {
                console.log(error)
            });
        }
	}

	componentDidMount () {
		let url = appConfig.apiUrl + 'patients/' + this.state.patient_id + '/payments';

		axios.get(url).then((res) => {
            let data = res.data.data;
            
            $('#paymentsTable').dataTable().fnDestroy();

            data.forEach((item, i) => {

                if((item.total_bill - Number(item.balance)) > 0)
                {
                    item.status = 'Partly Paid';
                }

                if(Number(item.balance) <= 0)
                {
                    item.status = 'Fully Paid';

                }

                if((item.total_bill - Number(item.balance)) == 0)
                {
                    item.status = 'Fully Paid';

                }

                if(item.is_voided == 1)
                {
                    item.status = 'Voided';
                }
                
            	item.payment_date = moment(item.payment_date).format('MMMM DD, YYYY');
                item.amount_paid = parseFloat(item.amount_paid).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                item.balance = parseFloat(item.balance).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            });

            this.setState({data},() => {
                
                setTimeout(() => {
                	$('#paymentsTable').DataTable({
                        'autoWidth': true,
                        'iDisplayLength': 5,
                        'lengthMenu' : [ 5, 10, 20, 50, 100 ],
                        'language' : {
                            "emptyTable" : 'No Payments Available'
                        },
                        retrieve: true,
                        'columnDefs': [
                            {
                                'targets': [7,6,5], // id last column
                                'visible': false,
                                'searchable': false
                            }
                        ],
                        'order': [[7,'DESC']]
                    });
                },500)
            });

        }).catch((error) => {
        	console.log(error)
        });
	}

	render() {
		return (
			<Table headers={this.state.headers} data={this.state.data} id="paymentsTable" />	
		)
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Treatment_record/Payments.js
 **/